import {
  ThemeProvider,
} from '@mui/material';
import { useEffect } from 'react';
import { ContentTheme } from './ContentTheme';
import { useIsMobile } from '../../../common/hooks/useResponsive';
import ContentViewMoreContainer from './ContentViewMoreContainer';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { ResetContentList, selectContentList, selectGetContentListState } from '../../../store/slices/contentSlice';
import { ContentCategory } from '../../../common/enums';
import { getContent } from '../../../store/thunks/contentThunk';
import ContentHorizontalCardSkeleton from './ContentHorizontalCardSkeleton';

export function SavedContent() {
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();
  const pageSize = isMobile ? 5 : 15;
  const storeContentList = useAppSelector(selectContentList); // using the generic content list
  const getContentListState = useAppSelector(selectGetContentListState);

  useEffect(() => {
    dispatch(ResetContentList([])); // initial content list state
    dispatch(getContent({
      pageSize,
      page: 1,
      onlySavedContent: true,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={ContentTheme}>
      {getContentListState === 'pending' ? <ContentHorizontalCardSkeleton /> : <ContentViewMoreContainer
        key='saved-content'
        categoryId={ContentCategory.TOPIC2}
        storeContentList={storeContentList}
        hasMoreContent={false}
        showSearchBar={false}
        showBackBtn={false}
        isSavedPage={true}
      />
      }
    </ThemeProvider>
  );
}
